exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".templates[data-v-fe6d9126]{width:100%;margin-top:20px}", ""]);

// exports
